import { PAGES_TYPES } from 'constants/pagesTypes';

import { retailTechExpertData } from './retailData';
import { defaultTechExpertData } from './defaultData';
import { finTechTechExpertData } from './fintechData';
import { aboutUsTechExpertData } from './aboutUsData';
import { telecomTechExpertData } from './telecomData';
import { itSupportTechExpertData } from './itSupportData';
import { oilAndGasTechExpertData } from './oilAndGasData';
import { consultingTechExpertData } from './consultingData';
import { cloudMigrationTechExpertData } from './cloudMigrationData';

export const techExpertDataSelector = {
  [PAGES_TYPES.cloudMigration]: cloudMigrationTechExpertData,
  [PAGES_TYPES.consulting]: consultingTechExpertData,
  [PAGES_TYPES.itSupport]: itSupportTechExpertData,
  [PAGES_TYPES.oilAndGas]: oilAndGasTechExpertData,
  [PAGES_TYPES.telecom]: telecomTechExpertData,
  [PAGES_TYPES.finTech]: finTechTechExpertData,
  [PAGES_TYPES.aboutUs]: aboutUsTechExpertData,
  [PAGES_TYPES.retail]: retailTechExpertData,

  default: defaultTechExpertData,
};
